module.exports = __webpack_public_path__ + "img/default-header-img.5a71f92b.png";